import React, { useRef } from 'react';
import { observer } from 'mobx-react-lite';

import { Separator } from '../common/Separator';
import { IListViewProps, ListView } from '../views/ListView';
import { MessageItem } from './MessageItem';
import type { FlatListRefType } from '../common/FlatList';
import type { Message } from '@models/Chats/MessageModel';

interface IMessageListProps
  extends Omit<IListViewProps<Message>, 'renderItem'> {
  data: Message[];
}

export const MessageList = observer<IMessageListProps>(
  ({ data, ...props }) => {
    const listRef = useRef<FlatListRefType>(null);

    /**
     * Adds ability to auto-scroll to to the last message
     * of a chat conversation when new messages are received or sent
     */
    function scrollToTop() {
      listRef.current?.scrollToOffset({
        offset: 0,
        animated: true,
      });
    }

    return (
      <ListView<Message>
        inverted
        listRef={listRef}
        onLayout={scrollToTop}
        keyExtractor={(i) => i.id.toString()}
        data={data}
        renderItem={({ item }) => <MessageItem item={item} />}
        ListHeaderComponent={Separator}
        ItemSeparatorComponent={() => <Separator size="$8" />}
        {...props}
      />
    );
  },
);
